
import { useEffect,useState } from "react";
import Button from '@mui/material/Button';
import {BtnSecondary, BtnPrimary } from "../../components/buttons";
import axios from "axios";
import "./adminManage.scss";
// import '../userManagement/userManage.scss'
import { Link as RouterLink, useNavigate ,useLocation} from "react-router-dom";
import { Edit} from "@mui/icons-material";
import { useSelector,useDispatch } from "react-redux";
import toastr from "toastr";
import {format} from 'date-fns'

import { useQuery, useQueryClient } from "react-query";
import Pagination from "../../components/pagination";
import DBSearchBar from "../../components/dBSearchBar";
import TableFeatures from "../../components/tableFeatures";
import TransactionSearchBar from "../../components/transactionSearchBar";
import DynamicDataValue from "../formPages/dynamicDataValue";
import ApprovalModal from "../../components/approvalModal";


const CONFIG = {
    headers: {
        Accept: 'application/json; charset=utf-8',
        'Content-Type': 'application/json',
      },
      withCredentials:true,
      credentials:'include'
    }


const TablePageOne = (props)=>{

    const [fieldName,setFieldName] = useState('all');
    const [field,setField] = useState('');
    const [startDateFilter,setStartDateFilter] = useState(null);
    const [endDateFilter,setEndDateFilter] = useState(null);
    const [sortFieldName,setSortFieldName] = useState('whenentered');
    const [sortOrder,setSortOrder] = useState(-1);
    // const [errorField,setErrorField] = useState("");
    const [dbEntries, setDbEntries] = useState([]);
    const [page,setPage] = useState([]);
    const [responseLength,setResponseLength] = useState();

    const [userSearch,setUserSearch] = useState('');
    const [courseName,setCourseName] = useState('');
    const [failedDataLength,setFailedDataLength] = useState('');
    
    const [skipData,setskipData] = useState(0);
    const navigate = useNavigate();

    const dispatch = useDispatch()
    const queryClient = useQueryClient();
 
    const PAGE_SET_LIMIT = 75;
    const usePath = useLocation();
   //console.log(usePath)
    const user = useSelector((state) => state.user.details);
    //setting input data on the page

useEffect(() =>{
   //console.log(page)
},[page])

   const submitForm = (e)=>{
    e.preventDefault();
        // if(field !== ''){
           
            setPageSetNum(0);
            setResponseLength(null)
            setDbEntries([])
           
        // }
        
        // else{
          
        //     setErrorField("please this field can't be empty!")   
            
           
        // }
        
    }
    
    
    let setPageSetNum;

    const pullPageSetNum = (setpageSetNum)=>{
       //console.log(setpageSetNum)
        setPageSetNum = setpageSetNum;
    }

    

    const reset = (e)=>{
        e.preventDefault();
    
        // window.location.reload(true);
        // setDbEntries([]);
        if(field !== ''){
            setField('');
            setFieldName('all');
            setSortFieldName('');
            setStartDateFilter('')
            setEndDateFilter('')
            setSortOrder(-1);
            setUserSearch("")
            setCourseName("")
            setDbEntries([]);
           
        }
      
        if(responseLength===0 ){
            window.location.reload(false);
            // setDbEntries([]);
            // setPage([])
        }
       
        
    }
    
   const getEntries= useQuery( [props.pageTitle,skipData],async()=>{
    //    try{
        
        const response = await axios.post(props.apiGETLink,{...props.apiBODY},{params:{fieldName,field,sortFieldName,sortOrder,skipData,startDateFilter,endDateFilter,userSearch,courseName},headers:CONFIG.headers});
        
       //console.log(response)     
    //console.log(dbEntries)   

             
            setDbEntries([...dbEntries,...response.data.dbEntries]);
            props.sendDataToParent&&props.sendDataToParent(response.data.dbEntries)
            setResponseLength(response.data.dataLength);
            setFailedDataLength(response.data.failedDataLength);
            
            // setDbEntries([...dbEntries,...response.data.dbEntries]);
      
        return response.data
    
   },{refetchOnMount:true,refetchOnWindowFocus:false,retry:0})

   
   const useGetFetchQuery = (key) => {
        

        
        return  queryClient.getQueryData([key,0]);
        
    };

    const cachedQuery = useGetFetchQuery();

	    const deleteHandle = async (id,userid,index) => {
      try {
            console.log(id,userid,index,"delete")
            let deleteId =userid?userid:id  
            // return
        const response = await axios.delete(`${props.apiDELETELink}/${deleteId}`)
       console.log(response)
        if(response.status=="200"){
          
            toastr.success(`Deleted Succesfully`)
          
            let pageData = [...page]
            pageData.splice(index,1)
            setPage([...pageData])

    }
      } catch (error) {
        
      }
        }  
    const activateHandle = async (id,isActive) => {
       //console.log(isActive)
            // const isActiveData = {
            //     modifiedby : {
            //         userID :  user && user._id,
            //         useName : user && user.firstName
            //     },
            //     isactive : !isActive,
            // }
            const isActiveData =  {isactive : !isActive}
            
            const response = await axios.post(`${props.apiActiveLiink}/${id}`, 

            isActiveData
           
        )
        // useEffect(() =>{
           //console.log("response data", response)
        // },[])
        
        if(response.data.isactive === 1 || response.data.isactive === true){
           //console.log(true)
            toastr.success(`Activated Succesfully`)
            // toastr.success(`Deactivated Succesfully`)
        }
        else if(response.data.isactive === 0 || response.data.isactive === false ){
           //console.log(false)
            toastr.success(`Deactivated Succesfully`)
            // toastr.success(`Activated Succesfully`)
        }
    
        let pageData = page
        pageData.map((e)=>{
           //console.log(e)
            if(e._id===id){
                e.isactive = response.data.isactive
            }
        })
        setPage([...pageData])
        }  


    useEffect(()=>{
        if(sortFieldName!==""&&sortOrder!==""){
            
            if(responseLength>1000){

                setDbEntries([]);                
            }


            

        }
    },[sortFieldName,sortOrder])
    
    useEffect(()=>{
        if(sortFieldName!==""&&sortOrder!==""){
            // setDbEntries([]);

            setSortOrder(-1)
            

        }
    },[sortFieldName])


    useEffect(()=>{
        
       //console.log(dbEntries,'dbEntries updated')

       

        if(dbEntries.length===0&&responseLength!==0){
           //console.log('no entries')
            if(getEntries.data!==undefined&&responseLength===undefined){
               //console.log('cached entries',responseLength)
               setDbEntries(getEntries.data.dbEntries)
            }
            else{
               //console.log('new entries')
                getEntries.refetch();
            }
            

        } 
        // else{
        //     getEntries.refetch();
        // }
        
        //    changeSet(dbEntries)
           
        
        
    },[dbEntries,responseLength])
   
    useEffect(()=>{
       //console.log(getEntries.error)
       //console.log(page);
        if(getEntries.error){
            if(getEntries.error.response.status===401){
                queryClient.clear();
                toastr.error(getEntries.error.response.data.error);
                
                navigate("/login",{replace:true})
            }
        }

    },[getEntries])
    useEffect(()=>{
        
       //console.log(page);
        

    },[page])
    
    useEffect(()=>{
        
        // getEntries.refetch();  
       //console.log(CONFIG.headers)

    },[])
    
    
    return(
        <>
         <div style={{paddingBottom:"100px"}}>
          
            <h1>{props.pageTitle}</h1>
            <div style={{display:"flex",justifyContent:"space-between"}}>
          
           {props.showPayoutSearchField ?
          <div>
          {props.showSearchBar&&<TransactionSearchBar
             selectItems={props.dBFields}
             fieldName={fieldName}
             setFieldName={setFieldName}
            startDateFilter = {startDateFilter}
            setStartDateFilter = {setStartDateFilter}
            endDateFilter = {endDateFilter}
            setEndDateFilter = {setEndDateFilter}
             dateFilter={props.dateFilter}
             field={field}             
             setField={setField}
             submitForm={submitForm}
             reset ={reset}
             userSearch={userSearch}
             setUserSearch={setUserSearch}
             courseName={courseName}
             setCourseName={setCourseName}
             
             />}
          </div>
           
           :<div> {props.showSearchBar&&<DBSearchBar
             selectItems={props.dBFields}
             fieldName={fieldName}
             setFieldName={setFieldName}
            startDateFilter = {startDateFilter}
            setStartDateFilter = {setStartDateFilter}
            endDateFilter = {endDateFilter}
            setEndDateFilter = {setEndDateFilter}
             dateFilter={props.dateFilter}
            //  setErrorField={setErrorField}
            //  errorfield={errorField && <div className="err-msg">{errorField}</div>}
             field={field}             
             setField={setField}
             submitForm={submitForm}
             reset ={reset}
             />}</div>}
             {/* bulk download */}
              <div> {props.extraBeforePage}</div>
             </div>

             {props.showTableFeatures&&<TableFeatures
                selectItems={props.dBFields}
                sortOrder={sortOrder}
                setSortOrder={setSortOrder}
                sortFieldName={sortFieldName}
                setSortFieldName={setSortFieldName}
                dbEntries={dbEntries}
                setDbEntries={setDbEntries}
                failedDataLength={failedDataLength}
                setFailedDataLength={setFailedDataLength}
                responseLength={responseLength}
                formLink={props.formLink}
                apiPOSTLink={props.apiPOSTLink}
                apiGETLink={props.apiGETLink}
                apiBODY={props.apiBODY}
                apiPATCHLink={props.apiPATCHLink}
                apiParams = {{fieldName,field,sortFieldName,sortOrder,skipData,startDateFilter,endDateFilter}}
                linkPageTitle = {`Add ${props.linkPageTitle}`}
                downloadXlsxFileName={props.downloadXlsxFileName}
                total={getEntries.isLoading?0:getEntries.isError?0:getEntries.data.dataLength}
                show={{downloadBtn:props.showDownloadBtn,addBtn:props.showAddBtn,total:props.showTotal}}
                showSortOrder={props.showSortOrder} 
                showPayoutStatusCount={props.showPayoutStatusCount} 
             />}

            <div className="entries-table-container">
                {
               getEntries.isLoading ? (
                <h2 className="alt-msg">Loading...</h2>
              ) : getEntries.isError ? (
                <h2 className="alt-msg">{getEntries.error.message}</h2>
              )  : getEntries.isFetching ? (
                <h2 className="alt-msg">Getting fresh data, Please wait...</h2>
              ) : responseLength === 0 ? (
                <h2 className="alt-msg">No Records Found</h2>
              ):
             
                <table className="">
                    <thead>
                        <tr>
                            <th>Sr.no</th>
                            {props.dBFields.map((field)=>{
                                if(field.show===false){
                                    return;
                                }
                                return(
                                    <th key={field.value}>{field.name}</th>
                                )
                            })}
                            
                            {props.showAction && <th>Actions</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {page.map((entry,index)=>{
                            // if(index<=skipData)
                           //console.log(entry.isactive)
                            
                            return(
                                    <tr key={entry._id}>
                                        <td>{entry.srNum+1}</td>
                                        {props.dBFields.map((field)=>{
                                        //console.log(field)
                                            if(field.show===false){
                                                    return;
                                            }
                                            // {console.log(entry[field.value])}
                                            if(entry[field.value] === null){
                                                return (
                                                     <td>{"N/A"}</td>  
                                                )
                                              
                                            }
                                           
                                            
                                            
                                            
                                            
                                                return(Array.isArray(entry[field.value])&&typeof(entry[field.value][0])==='object')?(

                                                    <td key={field.value}>
                                                    {(field.valueKey)?( entry[field.value].map((e,index)=>{
                                                            //console.log("array")
                                                        return(index+1===entry[field.value].length)?(e[field.valueKey]):(
                                                            
                                                           
                                                            `${e[field.valueKey]}, `
                                                        )
                                                    })):(<td>{entry[field.value].length}</td>)}
                                                    </td>
                                                )
                                                :(!Array.isArray(entry[field.value])&&typeof(entry[field.value])==='object')?
                                                 <>
                                            
                                            
                                                <td key={field.value}>
                                                    {entry && entry[field.value] && entry[field.value][field.valueKey]}
                                                </td>
                                            
                                             </>
                                            :
                                                
                                                (field.fieldType==="date")?(
                                                
                                                    <td key={field.value}>{entry[field.value]?format(new Date(entry.whenentered),'dd/MM/yyyy'):""}</td>
                                       
                                                ):(field.internalFields)?(
                                                    // console.log(field.internalFields,"mnnnnn")
                                                    <td style={{padding:"20px",textAlign:"left"}} key={field.value}>
                                                     {field.internalFields.map((subEntry,index)=>{

                                                    return(
                                                        
                                                        // <td style={{padding:"20px"}} key={field.value}>
                                                        <>
                                                        {subEntry.fieldType==="date"?
                                                        <p><strong>{subEntry.name}</strong>: {format(new Date(entry[subEntry.value]),'dd/MM/yyyy')}<br></br>
                                                        <strong>{subEntry.title}</strong>: { new Date(entry[subEntry.value]).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) }<br></br>
                                                        {/* { entry.requesttime && <><strong>{"Requesttime"}</strong>: { new Date(entry["requesttime"]).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) } </>} */}

                                                        </p>:<>{subEntry.fieldType !=="status"&& <p><strong>{subEntry.name}</strong>:{entry[subEntry.value]}</p>}</>}
                                                       
                                                        {/* {props.showPayoutStatusCount && subEntry.fieldType==="status"&& <p> <DynamicDataValue showAlignment="left" currentStatus={entry["status"]} /> </p>} */}
                                                        </>
                                                       
                                                        // </td>
                                                      
                                                    )
                                                })}
                                                </td>
                                                    // <td style={{padding:"20px"}} key={field.value}>{"aaaa"} </td>
                                                   
                                                ):(
                                                    <td style={{padding:"20px"}} key={field.value}>{entry[field.value]?entry[field.value].toString():field.onlyForTrans && !entry.transactionid?"N/A":entry.paymenttype =="subscription"?"Subscription": "N/A"} </td>
                                                   
                                                )
                                        })}
                                       
                                        
                                        
                                       {props.showAction &&<td>
                                            <div className="entry-table-actions" style={{marginLeft:"20%",paddingRight:"30px"}}>
                                        {props.showAction &&props.showTableEditBtn && <RouterLink to={props.formLink} state={{editEntry:entry,title:`Edit ${props.linkPageTitle}`,dBFields:props.dBFields,apiPOSTLink:props.apiPOSTLink,apiPATCHLink:props.apiPATCHLink}}>
                                            <BtnSecondary>
                                                <Edit sx={{fontSize:"8px"}}/> EDIT
                                            </BtnSecondary>
                                        </RouterLink>}

                                    

                                        {props.showAction &&props.showTableDetailsBtn && 
                                         <RouterLink to="/show-details" state={{entryId:entry._id,title:'User details',dBFields:props.dBFields,apiGETLink:props.apiGETLink,apiPATCHLink:props.apiPATCHLink}}><BtnSecondary>DETAILS</BtnSecondary></RouterLink>
                                        } 
                                            
                                        {props.moreBtns}
                                

                                    {/* <div>{props.showAction &&props.showViewPanelBtn&&
                                          <RouterLink to="/login" target="_blank" state={{entryId:entry._id,title:'Event Panel',dBFields:props.dBFields,apiGETLink:props.apiGETLink,apiPATCHLink:props.apiPATCHLink}}><BtnSecondary>VIEW PANEL</BtnSecondary></RouterLink>}</div> */}
                                          {props.showAction &&props.showTableDeactivateBtn&&<BtnPrimary  action={() =>activateHandle(entry._id, entry.isactive)}>
                                      {entry.isactive ?  "DEACTIVATE":"ACTIVATE"}
                                            </BtnPrimary>}
											  {props.showAction &&props.showTableDeleteBtn&&<BtnPrimary  action={() =>deleteHandle(entry._id,entry.userid, index)}>
                                           {"DELETE"}
                                            </BtnPrimary>}

                                            {props.showAction &&props.showInvoicBtn && (entry.invoicenum ||((entry.transactionid || entry.paymenttype =="subscription") && entry["status"] !== "failed" && entry.pgpaymentstatus&&entry.pgpaymentstatus!=="failed")) &&
                                            <ApprovalModal 
                                            invoiceid = {entry.invoicenum?entry._id:""}
                                            invoiceSendApi= {props.invoiceSendApi}
                                            transactionid= {entry.transactionid?entry.transactionid:""}
                                            subscriptionId= {entry.subscriptionId?entry.subscriptionId:""}
                                            showRefundBtn = {props.showRefundBtn}
                                            showInvoicBtn = {props.showInvoicBtn}
                                            >
                                          </ApprovalModal>}
                                          {/* {props.showAction &&props.showGiveAccess && entry.paymenttype !=="subscription" && (entry["status"] !== "failed" && entry.pgpaymentstatus&&entry.pgpaymentstatus!=="failed") &&  */}
                                           {props.showAction &&props.showGiveAccess &&  entry.paymenttype !=="subscription" && 
                                                <ApprovalModal 
                                                entry = {entry?entry:""}
                                                giveaccessapi= {props.giveaccessapi}
                                                showGiveAccess = {props.showGiveAccess}
                                                >
                                            </ApprovalModal>
                                          }
                                          {props.showAction && props.showPayoutStatusCount && props.showStatus && <p> <DynamicDataValue showAlignment="left" currentStatus={entry["status"]?entry["status"]:entry.subscriptionstatus?entry.subscriptionstatus:"created"} /> </p>}
                                          
                                            {props.showAction &&props.showViewPanelBtn&&
                                          <RouterLink to="/login" target="_blank" state={{entryId:entry._id,title:'Event Panel',dBFields:props.dBFields,apiGETLink:props.apiGETLink,apiPATCHLink:props.apiPATCHLink}}><BtnSecondary>VIEW PANEL</BtnSecondary></RouterLink>}
                                            {props.showAction &&props.showTableEventBtn&&
                                          <RouterLink to="/organiserevent-management" state={{editEntry:entry,entryId:entry._id,title:'Event View',dBFields:props.dBFields,apiGETLink:props.apiGETLink,apiPATCHLink:props.apiPATCHLink}}> <Button sx={{ backgroundColor:"rgb(13, 180, 231)" }}  variant="contained">VIEW EVENTS</Button> </RouterLink>}
                                          
                                        </div></td>}
                                    </tr>
                                )
                        })}
                    </tbody>
                </table>
                }
                <Pagination
                 pageSetLimit = {PAGE_SET_LIMIT} 
                 responseLength = {responseLength}
                 setPage = {setPage}
                 getNextData = {setskipData}
                 data = {dbEntries}
                 pageSetNum = {pullPageSetNum}
                 />
                
            </div>
           </div>
            
        </>
    )
}

TablePageOne.defaultProps ={
    
        showSearchBar:true,
        showTableFeatures:true,
        showTableEditBtn:true,
        showTableDeactivateBtn:true,
		showTableDeleteBtn:false,
        showDownloadBtn:true,
        showAddBtn:true,
        showTotal:true,
    
}



export default TablePageOne